class BodProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form')
    this.select = this.querySelector('[data-variant-select]')
    this.price = this.querySelector('[data-product-price]')
    this.button = this.querySelector('[data-add-to-cart]')
    this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]')
    this.idleButtonText = this.button?.textContent.trim()
    this.idleMobileSymbol = this.button?.dataset.mobileSymbol
    this.form?.addEventListener('submit', (event) => this.submit(event))
    this.select?.addEventListener('change', () => this.updateVariant())
  }

  async submit(event) {
    if (event.submitter && event.submitter !== this.button) return
    if (this.useNativeSubmitOnRetry) return

    event.preventDefault()
    if (this.pending || !this.form || !this.button) return

    this.pending = true
    this.button.disabled = true
    this.button.textContent = 'Adding…'
    if (this.button.dataset.mobileSymbol) this.button.dataset.mobileSymbol = '…'

    const root = window.Shopify?.routes?.root || '/'

    try {
      const addResponse = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.form),
      })
      const addedItem = await addResponse.json()
      if (!addResponse.ok) {
        showCartStatus(addedItem.description || addedItem.message || 'Unable to add this item to your cart.', false)
        return
      }

      showCartStatus(`${this.dataset.productTitle || addedItem.product_title || addedItem.title || 'Item'} added to your cart.`, true)

      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
        const cart = await cartResponse.json()
        if (cartResponse.ok) updateCartCount(cart.item_count)
      } catch {
        // The item is already in the cart; keep the success confirmation visible.
      }
    } catch {
      this.useNativeSubmitOnRetry = true
      showCartStatus("We couldn't add this item without leaving this page. Try again to use the standard cart.", false)
    } finally {
      this.pending = false
      this.button.disabled = false
      this.button.textContent = this.idleButtonText || 'Add to cart'
      if (this.idleMobileSymbol) this.button.dataset.mobileSymbol = this.idleMobileSymbol
    }
  }

  updateVariant() {
    const variant = this.variants.find(({ id }) => String(id) === this.select.value)
    if (!variant) return

    if (this.price) this.price.textContent = variant.formatted_price
    if (this.button) {
      this.button.disabled = !variant.available
      this.button.textContent = variant.available ? 'Add to cart' : 'Sold out'
      if (this.button.dataset.mobileSymbol) {
        this.idleMobileSymbol = variant.available ? '+' : '×'
        this.button.dataset.mobileSymbol = this.idleMobileSymbol
      }
    }

    if (this.hasAttribute('data-update-url')) {
      const url = new URL(window.location.href)
      url.searchParams.set('variant', variant.id)
      window.history.replaceState({}, '', url)
    }
  }
}

function updateCartCount(itemCount) {
  const cartLink = document.querySelector('[data-cart-link]')
  if (!cartLink) return

  cartLink.setAttribute('aria-label', `Cart with ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`)
  let badge = cartLink.querySelector('.cart-count')

  if (itemCount > 0) {
    if (!badge) {
      badge = document.createElement('span')
      badge.className = 'cart-count'
      cartLink.append(badge)
    }
    badge.textContent = itemCount
  } else {
    badge?.remove()
  }
}

function showCartStatus(message, showCartLink) {
  const status = document.querySelector('[data-cart-status]')
  const messageElement = document.querySelector('[data-cart-status-message]')
  const visualMessage = status?.querySelector('[data-cart-status-visual]')
  const cartLink = status?.querySelector('[data-cart-status-link]')
  if (!status || !messageElement || !visualMessage) return

  messageElement.textContent = message
  visualMessage.textContent = message
  if (cartLink) cartLink.hidden = !showCartLink
  status.hidden = false
}

if (!customElements.get('bod-product-form')) {
  customElements.define('bod-product-form', BodProductForm)
}

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-cart-status-close]')) {
    const status = document.querySelector('[data-cart-status]')
    if (status) status.hidden = true
  }
})
